<template>
  <div>
    <div v-if="temFormulario" class="container">
      <div
        class="card"
        style="margin-bottom: 1vh;"
        v-for="formulario in formularios"
        :key="`formulario_${formulario.formularioId}`"
      >
        <div class="formulario-item2">
          <div class="card-header">{{ formulario.tituloFormulario }}</div>
          <div class="card-body">
            <div class="row" v-if="formulario.titulo.length > 0">
              <div class="col">
                <h5 class="card-title">{{ formulario.titulo }}</h5>
              </div>
            </div>
            <div class="row">
              <div class="col">
               <small>
                Périodo de <b>{{ formulario.dataInicioFormatado }}</b> até
                <b>{{ formulario.dataFimFormatado }}</b>
               </small>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col">
                <p class="card-text" v-html="formulario.descricao"></p>
              </div>
            </div>
            <br />
            <div class="row align-items-end justify-content-center">
              <div class="col">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="verificarAceiteTermo(formulario)"
                >
                  Responder
                </button>
              </div>
            </div>
          </div>
        </div>
        <br />
    
      </div>
    </div>
    <div v-else>
      <p class="alert alert-info alert-block" v-if="!carregandoFormulario">
        Nenhum formulário disponível para responder.
      </p>
      <p class="alert alert-warning alert-block" v-if="carregandoFormulario">
        Carregando...
      </p>
    </div>
  </div>
</template>

<script>
import { USER_CONFIG } from "../config/UserConfig";
import clienteService from "../services/ClienteService";
import storageService from "../services/storageService";
import notificacaoService from "../services/Notificacao.service";
import formularioService from "../services/FormularioService";
export default {
  name: "comp-formulario-disponivel-responder",
  data() {
    return {
      formularios: [],
      codigoCliente: "",
      pessoaId: "",
      carregandoFormulario: false,
    };
  },
  methods: {
    verificarAceiteTermo(formulario) {
      const { descricaoTermo, tipoTermo, termoId, formularioId } = formulario;
      const route = {
        name: "responderFormulario",
        params: {
          formularioId: formularioId,
          codigoCliente: this.codigoCliente,
          tipoTermo: tipoTermo,
        },
      };
      
      const notificacaoResult = notificacaoService.confirmacao(
        tipoTermo,
        descricaoTermo
      );
      notificacaoResult.then((result) => {
        if (result.value) {
          this.$router.push(route);
        } else {
          formularioService
            .recusarTermoFormulario(formularioId, this.pessoaId, termoId)
            .then((result) => {
              if (result.sucesso) {
                this.carregarListagemFormulario();
              } else {
                notificacaoService.erro(result.erros);
              }
            });
        }
      });
    },
    carregarListagemFormulario() {
      this.carregandoFormulario = true;
      this.formularios = [];
      const clienteFormulario = storageService.getJsonItem(
        USER_CONFIG.clienteFormulario
      );
      const participante = storageService.getJsonItem(USER_CONFIG.loggedUser);
      //buscar os formularios
      if (
        clienteFormulario &&
        clienteFormulario.codigoCliente &&
        participante &&
        participante.pessoaId
      ) {
        const { pessoaId } = participante;
        const { codigoCliente } = clienteFormulario;
        clienteService
          .obterFormulariosDisponiveis(codigoCliente, pessoaId)
          .then((formularios) => {
            this.formularios = formularios;
            this.carregandoFormulario = false;
          })
          .catch(() => (this.carregandoFormulario = false));

        this.codigoCliente = clienteFormulario.codigoCliente;
        this.pessoaId = participante.pessoaId;

        this.$loading(false);
      }
    },
  },
  computed: {
    temFormulario() {
      return this.formularios.length > 0;
    },
  },
  updated() {},
  mounted() {
    this.$store.dispatch("descarregarFormulario", 0);
  },
  beforeMount() {
    this.carregarListagemFormulario();
  },
};
</script>

<style scoped>
.formulario-item {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/View/FormulariosDisponivelResponder.vue